import React, { useState, useEffect } from "react";
import "./badges.css";

import tt_question from "../../assets/images/tt_question.png";
import bdg_teamplayer from "../../assets/images/bdg_teamplayer.png";
import bdg_innovator from "../../assets/images/bdg_innovator.png";
import bdg_jock from "../../assets/images/bdg_jock.png";
import bdg_initiator from "../../assets/images/bdg_initiator.png";
import bdg_leader from "../../assets/images/bdg_leader.png";
import bdg_perfectionist from "../../assets/images/bdg_perfectionist.png";
import bdg_ecofriendly from "../../assets/images/bdg_ecofriendly.png";
import bdg_partystarter from "../../assets/images/bdg_partystarter.png";
import bdg_explorer from "../../assets/images/bdg_explorer.png";
import bdg_creative from "../../assets/images/bdg_creative.png";
import bdg_knowledgehungry from "../../assets/images/bdg_knowledgehungry.png";
import bdg_kind from "../../assets/images/bdg_kind.png";

function Badges() {
  const [userBadges, setUserBadges] = useState([]);
  const [otherBadges, setOtherBadges] = useState([]);
  const [badgeCount, setBadgeCount] = useState(0);
  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/badges/userbadge")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setUserBadges(data.userBadges);
          setOtherBadges(data.otherBadges);
          setBadgeCount(data.userBadges.length);
        }
      });
  }, []);

  const BadgeMessage = () => {
    if (badgeCount == 0) {
      return (
        <div className="tt-title-wrap">
          <div className="tt-title">
            <h1>You have not earned any Badges yet. </h1>
            <div className="tt-icon">
              <img src={tt_question} alt="tooltip" />
              <div className="tt-text">
                <p>These are the badges you have earned.</p>
              </div>
            </div>
          </div>
          <div className="bdg-sub-title">
            <p>Ask your friends to give you Badges</p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="tt-title-wrap">
          <div className="tt-title">
            <h1>
              Hurray, You have earned <span>{badgeCount} badges!</span>
            </h1>
            <div className="tt-icon">
              <img src={tt_question} alt="tooltip" />
              <div className="tt-text">
                <p>These are the badges you have earned.</p>
              </div>
            </div>
          </div>
          <div className="bdg-sub-title">
            <p>Keep up the great work!</p>
          </div>
        </div>
      );
    }
  };

  return (
    <section>
      <BadgeMessage />
      {/* <div className="tt-title-wrap">
                <div className="tt-title">
                  <h1>Hurray, You have earned <span>{badgeCount} badges!</span></h1>
                  <div className="tt-icon">
                    <img src={tt_question} alt="tooltip"/>
                    <div className="tt-text">
                      <p>These are the badges you have earned.</p>
                    </div>
                  </div>
                </div>
                <div className="bdg-sub-title">
                    <p>Keep up the great work!</p>
                </div>
            </div> */}

      <div className="bdg-wrap">
        <h3 className="bdg-title">My Badges</h3>
        <div className="bdg-flex">
          {userBadges.map((badge, index) => (
            <div
              key={index}
              className="bdg-img-wrap bg-imgs"
              style={{
                backgroundImage: `url(${process.env.REACT_APP_API_URL +
                  "api/images/badges/" +
                  badge.BadgeImage
                  })`,
              }}
            ></div>
          ))}
          {/* <div className="bdg-img-wrap bg-imgs" style={{backgroundImage:`url(${bdg_teamplayer})`}}></div>
                  <div className="bdg-img-wrap bg-imgs" style={{backgroundImage:`url(${bdg_innovator})`}}></div>
                  <div className="bdg-img-wrap bg-imgs" style={{backgroundImage:`url(${bdg_jock})`}}></div> */}
        </div>
      </div>
      <div className="bdg-wrap">
        <h3 className="bdg-title">Other Badges To Earn</h3>
        <div className="other-bdg-flex">
          {otherBadges.map((badge, index) => (
            <div
              key={index}
              className="other-bdg-wrap bg-imgs"
              style={{
                backgroundImage: `url(${process.env.REACT_APP_API_URL +
                  "api/images/badges/" +
                  badge.BadgeImage
                  })`,
              }}
            >
              <div className="other-bdg-overlay"></div>
            </div>
          ))}
          {/* <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_initiator})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div> */}
          {/* <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_leader})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div>
                  <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_perfectionist})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div>
                  <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_ecofriendly})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div>
                  <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_partystarter})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div>
                  <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_explorer})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div>
                  <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_creative})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div>
                  <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_knowledgehungry})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div>
                  <div className="other-bdg-wrap bg-imgs" style={{backgroundImage:`url(${bdg_kind})`}}>
                    <div className="other-bdg-overlay"></div>
                  </div> */}
        </div>
      </div>
    </section>
  );
}

export default Badges;
